




















import bowser from 'bowser';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CompatibleBrowser extends Vue {
  visible = false;

  public hideMessage () {
    this.visible = false;
  }

  mounted () {
    if (bowser.msie) {
      this.visible = true;
    }
  }
}
